import React from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import ticketIcon from '../../assets/ticket-icon.svg';
import {
  BANNER_GRADIENT,
  BANNER_HEIGHT,
  BANNER_SUBTITLE_COLOR,
  CARD_MAX_WIDTH
} from '../ticket-form/layout';

// Figma: Submit New ticket_Slot — Rectangle 57
// Linear gradient #2E3F80 → #1C264D, 171px height, full-bleed header.
const TicketFormBanner = ({ title, subtitle }) => (
  <Box
    data-testid="ticket-form-banner"
    sx={{
      background: BANNER_GRADIENT,
      color: '#fff',
      minHeight: BANNER_HEIGHT,
      boxSizing: 'border-box',
      display: 'flex',
      alignItems: 'flex-start',
      pt: 3
    }}
  >
    <Box sx={{ maxWidth: CARD_MAX_WIDTH, mx: 'auto', px: 4, width: '100%' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Box
          component="img"
          src={ticketIcon}
          alt=""
          aria-hidden
          sx={{
            height: 20,
            width: 'auto',
            // Icon SVG fill is #27366D; invert for contrast on the dark gradient.
            filter: 'brightness(0) invert(1)'
          }}
        />
        <Typography variant="h4" component="h1" sx={{ color: '#fff', fontWeight: 700 }}>
          {title}
        </Typography>
      </Box>
      {subtitle && (
        <Typography
          variant="body2"
          sx={{ color: BANNER_SUBTITLE_COLOR, mt: 0.5, maxWidth: '100%' }}
        >
          {subtitle}
        </Typography>
      )}
    </Box>
  </Box>
);

TicketFormBanner.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string
};

export default TicketFormBanner;
